import { useQuery } from '@apollo/client';
import { isEmpty, isNil } from 'lodash';
import { Queries } from '@shared/api';

export function useWorkflowEntitiesByIds({
  workflowTemplateId,
  workflowEntityIds,
}: {
  workflowTemplateId?: string | null;
  workflowEntityIds?: string[];
}): {
  workflowTemplate?: MBAPI.WorkflowTemplate;
  workflowEntities: MBAPI.WorkflowEntity[];
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    MBAPI.GetWorkflowEntitiesQuery,
    MBAPI.GetWorkflowEntitiesQueryVariables
  >(Queries.workflow.getWorkflowEntities, {
    variables: {
      input: {
        ids: workflowEntityIds ?? [],
        workflowTemplateId: workflowTemplateId ?? '',
      },
    },
    skip: isNil(workflowTemplateId) || isEmpty(workflowEntityIds),
  });
  const workflowEntities = data?.workflowEntities?.entities?.filter(e => !isNil(e)) ?? [];
  const workflowTemplate =
    data?.workflowEntities?.refs?.workflowTemplateRefs?.find(
      wft => wft.id === workflowTemplateId,
    ) ?? undefined;

  return { workflowTemplate, workflowEntities, loading, error };
}
